import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

// Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectUserData } from '../../store/selectors';

// i18n
import { useTranslation } from "react-i18next";


const SidebarContent = props => {

  const ref = useRef();
  const { t } = useTranslation('SidebarContent');


  //--------------------------------------------------
  // User Data and Roles
  //--------------------------------------------------
  const { userData } = useSelector(selectUserData);

  const [role, setRole] = useState(userData?.role ?? '');
  useEffect(() => { 
    if(userData?.role){ 
      //console.log("current role:", role);
      setRole(userData?.role);
    } 
  }, [userData?.role]);



  const [isMyAIEditor, setIsMyAIEditor] = useState(userData?.isMyAIEditor ?? false);
  const [isMyAIUser, setIsMyAIUser] = useState(userData?.isMyAIUser ?? false);
  useEffect(() => { 
    if(userData?.isMyAIEditor){ setIsMyAIEditor(userData?.isMyAIEditor); }
  }, [userData?.isMyAIEditor]);
  useEffect(() => { 
    if(userData?.isMyAIUser){ setIsMyAIUser(userData?.isMyAIUser); } 
  }, [userData?.isMyAIUser]);
  


  //--------------------------------------------------
  // Dropdown Toggles
  //--------------------------------------------------

  const activateParentDropdown = useCallback((item) => {

    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();

  const activeMenu = useCallback(() => {
    
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }

    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }

  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu"
            style={{
              overflow: 'scroll',
              scrollbarWidth: 'none'
            }}
          >

            <li className="menu-title">{t("Menu")} </li>

            <li>
              <Link to="/#">
                <i className="bx bx-home-circle"></i>
                <span>{t("Feature Overview")}</span>
              </Link>

              {/* 功能總覽項目 */}
              <ul className="sub-menu" style={{ }} >
                <li>
                  <Link to="/dashboard">{t("Home")}{`| TTMY.AI`}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow " 
                style={{ display: (((role === 'admin' || isMyAIEditor) || isMyAIUser) ? 'block' : 'none') }}
              >
                <i className="bx bx-user-check"></i>
                <span>{t("Personalized AI Applications")}</span>
              </Link>
              <ul className="sub-menu">
                {(role === 'admin' || isMyAIEditor) && (
                  <>
                    <li>
                      <Link to="/myInfo/chooseTopic">{t("測試主題填寫")}</Link>
                    </li>
                    <li>
                      <Link to="/editInfoThemeList">{t("管理問題集")}</Link>
                    </li>
                  </>
                )}
                {((role === 'admin' || isMyAIEditor) || isMyAIUser) && (
                  <>
                    <li>
                      <Link to="/myInfo/dashboard">{t("我的 AI 應用主頁")}</Link>
                    </li>
                    <li>
                      <Link to="/myInfo/storeMenu">{t("商店列表")}</Link>
                    </li>
                    <li>
                      <Link to="/myInfo/infoFeed">{t("貼文動態牆")}</Link>
                    </li>
                    <li>
                      <Link to="/myInfo/feed">{t("貼文動態牆範例")}</Link>
                    </li>
                    <li>
                      <Link to="/myInfo/profile">{t("我的主題列表")}</Link>
                    </li>
                  </>
                )}
                {(role === 'admin') && (
                  <>
                    <li>
                      <Link to="/myInfo/questions/680ee3dac057729bb8a5b167/manageOptions">{t("管理問題統計")}</Link>
                    </li>
                    <li>
                      <Link to="/adminRedemptionManagement">{t("點數兌換管理")}</Link>
                    </li>
                    <li>
                      <Link to="/adminBankInfo">{t("查詢銀行帳號")}</Link>
                    </li>
                    <li>
                      <Link to="/agent-create">{t("Explore Other AIs")}</Link>
                    </li>
                    <li>
                      <Link to="/agent-rule">{t("AI Activity Wall")}</Link>
                    </li>
                  </>
                )}
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-credit-card-alt"></i>
                <span>{t("TheChart Points")}</span>
              </Link>
              <ul className="sub-menu" style={{ }}>
                <li>
                  <Link to="/purchase-point">{t("Purchase TheChart Points")}</Link>
                </li>
                <li>
                  <Link to="/purchase-point-history">{t("Points Purchase History")}</Link>
                </li>
              </ul>
            </li>


            
            
            <li>
              <Link to="/#" className="has-arrow " style={{ display: (role === 'admin'?'block':'none') }}>
                {/*<i className="bx bx-cog"></i>*/}
                {/*<i className="bx bx-slider-alt"></i>*/}
                {/*<i className="bx bx-user-pin"></i>*/}
                {/*<i className="bx bx-lock"></i>*/}
                {/*<i className="bx bx-dashboard"></i>*/}
                {/*<i className="bx bx-tachometer"></i>*/}
                <i className="bx bx-key"></i>
                {/*<i className="bx bx-wrench"></i>*/}
                {/*<i className="bx bx-bar-chart-alt-2"></i>*/}
                {/*<i className="bx bx-line-chart"></i>*/}
                <span>{t("Administrator")}</span>
              </Link>
              <ul className="sub-menu" style={{ }}>
                {role === 'admin' && (
                  <>
                    <li>
                      <Link to="/dashboard-cabin">{t("Admin Panel")}</Link>
                    </li>
                    <li>
                      <Link to="/whitelist-manager">{t("Whitelist Manager")}</Link>
                    </li>
                    <li>
                      <Link to="/userdict-manager">{t("UserDict Manager")}</Link>
                    </li>
                    <li>
                      <Link to="/tutorial-videos">{t("Tutorial Videos")}</Link>
                    </li>
                    <li>
                      <Link to="/video-manager">{t("Video Manager")}</Link>
                    </li>
                    <li>
                      <Link to="/qna-management">{t("Q&A Manager")}</Link>
                    </li>
                  </>
                )}
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow " style={{ display: 'block' }}>
                <i className="bx bx-map-alt"></i>
                <span>{t("About")}</span>
              </Link>
              <ul className="sub-menu" style={{ }}>
                <li>
                  {/*
                  <a href="https://bytelingo.co/tutorial" target="_blank" rel="noopener noreferrer">
                    {t("User Guide")}
                  </a>
                  */}
                  <a href="https://stream-advantage-019.notion.site/TheChartAI-1c0498c79c4c808680c6ffab7f45a7d6" target="_blank" rel="noopener noreferrer">
                    {t("User Guide")}
                  </a>
                </li>
                {role === 'admin' && (
                  <>
                    <li>
                      <Link to="/order-list">{t("What is TheChart?")}</Link>
                    </li>
                  </>
                )}
              </ul>
            </li>
            
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
};

export default withRouter(SidebarContent);
